<template>
    <van-tag v-if="status_text" :style="status_color">{{ status_text }}</van-tag>
</template>

<script>
    export default {
      name: "status-tag",
      props: {
        status_color:'',
        status_text:'',
        status:'',
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/status-tag.vue